import { connect } from 'react-redux'
import authSelector from 'modules/Auth/selectors'
import ManageProfile from 'modules/ManageProfile/index'
import { getUserRoles, getUserInfo } from 'modules/Auth/actions'

import {
  updateUserData,
  changePassword,
  updateNotification,
  checkOtp,
  SendOtp,
  deleteFile,
} from 'modules/ManageProfile/actions'
const mapStateToProps = state => ({
  userData: authSelector.getUserInfo(state),
  userRole: authSelector?.getUserRoleList(state),
})

const mapDispatchToProps = {
  getUserRoles,
  getUserInfo,
  updateUserData,
  changePassword,
  updateNotification,
  checkOtp,
  SendOtp,
  deleteFile,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageProfile)
